module.exports = __webpack_public_path__ + "media/images/flavours/icon-fermentaire_dark-7093d34a3d161304731540f9f96813c1.png";